import { general } from './general'
import { claim } from './claim'
import { list } from './list'
import { updateStatus } from './updateStatus'
import { post } from './post'

export const actions = Object.assign({}, general, claim, list, updateStatus, post)
